import MapLibreGL from "maplibre-gl";
import { Protocol } from "pmtiles";

// Registratie van het pmtiles-protocol, nodig voor elke kaart die de
// perceel-tileset laadt. Importeer deze module in zo'n kaart in plaats van te
// vertrouwen op het side effect van een andere component.
const protocol = new Protocol();
MapLibreGL.addProtocol("pmtiles", protocol.tile);

export const PARCEL_TILES = "pmtiles://https://ref.cadamap.com/tiles/combined_20260814.pmtiles";
// De tileset heeft twee lagen: `default` met de perceelvlakken (id = naam, zoals
// "GST00 I 1") en `label` met daarnaast `short_name`.
export const PARCEL_SOURCE_LAYER = "default";
